import { Routes, Route } from 'react-router-dom'
import Layout from './components/Layout'
import HomePage from './pages/HomePage'
import DocsRedirect from './pages/DocsRedirect'
import SwaggerRedirect from './pages/SwaggerRedirect'

function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<HomePage />} />
        <Route path="docs" element={<DocsRedirect />} />
        <Route path="swagger" element={<SwaggerRedirect />} />
      </Route>
    </Routes>
  )
}

export default App
